import { ToolBase } from ".";

export class SelectionTool extends ToolBase {

  setActive(value) {
    super.setActive(value);

    if(!value){
      this.imageEditor.canvas.discardActiveObject();
    }

    this.imageEditor.canvas.selection = value;
    this.imageEditor.canvas.forEachObject(function(obj) {
      obj.set({
        selectable: value,
        hoverCursor: !value ? 'default' : 'move'
      })
    });
  }

}